module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"download":"Baixar","title-paid":"Pedido concluído","title-not-paid":"Aguardando pagamento"}}')
  delete Component.options._Ctor
}
